import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { useDispatch, useSelector } from 'react-redux';
import {selectors, setFilterYear, setFilterSubject} from '../../features/schools/slice';

const useStyles = makeStyles((theme) => ({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
  }));

const yearFilter = () => {

    const classes = useStyles();

    const filterYear = useSelector(selectors.filterYear);
    const filterSubject = useSelector(selectors.filterSubject);
    const dispatch = useDispatch();

    const handleChange = (event) => {
        dispatch(setFilterYear(event.target.value));

        if (filterSubject.includes('opt') && event.target.value < 2022) {
          history.replaceState({} , '', '/?subject=fiz');
          dispatch(setFilterSubject('FIZ'));
        }
    }
    
    return <FormControl className={classes.formControl}>
      <InputLabel id="yearFilter">Mācību gads</InputLabel>
      <Select
        labelId="yearFilter-label"
        id="yearFilter-helper"
        value={filterYear}
        onChange={handleChange}
      >
        <MenuItem value={2024}>2023./24.</MenuItem>
        <MenuItem value={2023}>2022./23.</MenuItem>
        <MenuItem value={2022}>2021./22.</MenuItem>
        <MenuItem value={2021}>2020./21.</MenuItem>
        <MenuItem value={2020}>2019./20.</MenuItem>
        <MenuItem value={2019}>2018./19.</MenuItem>
        <MenuItem value={2018}>2017./18.</MenuItem>
      </Select>
      <FormHelperText>Izvēlieties mācību gadu</FormHelperText>
    </FormControl>
}

export default yearFilter;


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/letera/src/components/filters/year.js